/* ==========================================================================
   GeoRide — Flyout Newsletter 5 % (comportement)
   Clone ISO du form Klaviyo R8nJe5 : parcours Email -> Prénom -> Succès.
   Config lue depuis <script type="application/json" data-gr-nl-cfg> de la section.
   Aucune clé API : POST vers l'endpoint public Brevo (sibforms) -> liste 4.
   ========================================================================== */
(function () {
  var root = document.querySelector('[data-gr-nl]');
  if (!root) return;

  var cfgEl = root.querySelector('[data-gr-nl-cfg]');
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg.action) return; /* mode dégradé : pas d'endpoint -> pas d'affichage */

  var isDesktop = function () { return window.matchMedia('(min-width:750px)').matches; };

  /* ---------- storage helpers (fail-safe) ---------- */
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function ssGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  function cookie(n) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + n.replace(/([.$?*|{}()\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  var K_SUB = 'gr_nl_subscribed', K_DIS = 'gr_nl_dismissed_until', K_SESS = 'gr_nl_shown';

  /* ---------- analytics ---------- */
  function track(action, data) {
    var payload = { event: 'gr_newsletter_flyout', gr_nl_action: action };
    if (data) { for (var k in data) { if (data.hasOwnProperty(k)) payload[k] = data[k]; } }
    if (window.dataLayer && typeof window.dataLayer.push === 'function') { window.dataLayer.push(payload); }
    try { document.dispatchEvent(new CustomEvent('gr:newsletter:' + action, { detail: data || {} })); } catch (e) {}
  }

  /* ---------- mode preview QA : ?gr_nl=preview ----------
     Ouvre le flyout immédiatement à chaque chargement (bypass délai/scroll/
     exit-intent + gardes localStorage/sessionStorage). Aucun effet sans ce param. */
  var preview = false;
  try { preview = new URLSearchParams(window.location.search).get('gr_nl') === 'preview'; }
  catch (e) { preview = /[?&]gr_nl=preview/.test(window.location.search); }

  /* ---------- gate d'affichage (JS) ---------- */
  var design = cfg.designMode === true || preview;
  if (!design) {
    if (ssGet(K_SESS)) return;                         /* 1 fois / session */
    if (lsGet(K_SUB) === '1') return;                  /* déjà inscrit sur ce device */
    var until = parseInt(lsGet(K_DIS) || '0', 10);
    if (until && Date.now() < until) return;           /* dismiss < 30 j */
    if (cookie('discount_code')) return;               /* code promo partenaire actif */
  }

  /* ---------- refs ---------- */
  var card    = root.querySelector('.gr-nl__card');
  var live    = root.querySelector('[data-gr-nl-live]');
  var views   = {};
  Array.prototype.forEach.call(root.querySelectorAll('[data-gr-nl-view]'), function (v) {
    views[v.getAttribute('data-gr-nl-view')] = v;
  });

  var emailForm  = root.querySelector('[data-gr-nl-form="email"]');
  var emailInput = root.querySelector('[data-gr-nl-input="email"]');
  var emailBtn   = root.querySelector('[data-gr-nl-submit="email"]');
  var inline     = root.querySelector('[data-gr-nl-inline=""]') || root.querySelector('[data-gr-nl-inline]');
  var prenomInline = root.querySelector('[data-gr-nl-inline="prenom"]');
  var prenomForm  = root.querySelector('[data-gr-nl-form="prenom"]');
  var prenomInput = root.querySelector('[data-gr-nl-input="prenom"]');
  var prenomBtn   = root.querySelector('[data-gr-nl-submit="prenom"]');

  function btnLabel(btn) { return btn ? btn.querySelector('.gr-nl__cta-label') : null; }
  var emailBtnLabel  = btnLabel(emailBtn);
  var prenomBtnLabel = btnLabel(prenomBtn);
  var emailBtnDefault  = emailBtnLabel ? emailBtnLabel.textContent : '';
  var prenomBtnDefault = prenomBtnLabel ? prenomBtnLabel.textContent : '';

  var shown = false, armed = true, timer = null;
  var capturedEmail = '';

  function isEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }
  function announce(msg) { if (!live) return; live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 40); }

  function showView(name) {
    for (var k in views) { views[k].hidden = (k !== name); }
    root.setAttribute('data-view', name); /* pilote aussi l'image latérale */
  }
  function focusView(name) {
    var v = views[name]; if (!v) return;
    var h = v.querySelector('[data-gr-nl-focus]'); if (!h) return;
    try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); }
  }

  /* ---------- triggers ---------- */
  function disarm() {
    armed = false;
    if (timer) { clearTimeout(timer); }
    window.removeEventListener('scroll', onScroll);
    document.removeEventListener('mouseout', onExit);
  }
  function onScroll() {
    if (!armed) return;
    var st = window.pageYOffset || document.documentElement.scrollTop;
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (h > 0 && (st / h) >= cfg.scroll) { open(); }
  }
  function onExit(e) {
    if (!armed) return;
    if (!e.relatedTarget && !e.toElement && (e.clientY == null || e.clientY <= 0)) { open(); }
  }

  function open() {
    if (shown) return; shown = true; disarm();
    if (!design) { ssSet(K_SESS, '1'); }
    root.hidden = false;
    void root.offsetWidth; /* reflow puis animation d'entrée */
    requestAnimationFrame(function () {
      root.classList.add('gr-nl--open');
      document.body.classList.add('gr-nl-active');
    });
    track('impression', { page_type: cfg.pageType });
  }

  if (design) {
    open(); /* customizer : affichage immédiat pour l'édition */
  } else {
    timer = setTimeout(function () { if (armed) open(); }, cfg.delay);
    window.addEventListener('scroll', onScroll, { passive: true });
    if (isDesktop()) { document.addEventListener('mouseout', onExit); }
  }

  /* ---------- dismiss ---------- */
  function dismiss() {
    if (root.hidden) return;
    root.classList.remove('gr-nl--open');
    root.classList.add('gr-nl--closing');
    document.body.classList.remove('gr-nl-active');
    if (!design) { lsSet(K_DIS, String(Date.now() + 30 * 24 * 3600 * 1000)); }
    track('dismiss', { view: root.getAttribute('data-view') });
    setTimeout(function () { root.hidden = true; root.classList.remove('gr-nl--closing'); }, 380);
  }
  var closeBtn = root.querySelector('[data-gr-nl-close]');
  if (closeBtn) { closeBtn.addEventListener('click', dismiss); }
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.keyCode === 27) && !root.hidden && isDesktop()) { dismiss(); }
  });

  /* ---------- validation inline (email) ---------- */
  function setInvalid() {
    root.classList.add('gr-nl--invalid');
    if (inline) { inline.textContent = cfg.strings.inline; }
    if (emailInput) { emailInput.setAttribute('aria-invalid', 'true'); }
    announce(cfg.strings.inline);
  }
  function clearInvalid() {
    root.classList.remove('gr-nl--invalid');
    if (inline) { inline.textContent = ''; }
    if (emailInput) { emailInput.removeAttribute('aria-invalid'); }
  }
  if (emailInput) {
    emailInput.addEventListener('input', function () {
      if (root.classList.contains('gr-nl--invalid') && isEmail(emailInput.value.trim())) { clearInvalid(); }
    });
  }

  /* ---------- loading (par étape) ---------- */
  function setLoading(which, b) {
    root.classList.toggle('gr-nl--loading', b);
    if (which === 'email') {
      if (emailInput) { emailInput.disabled = b; }
      if (emailBtn) { emailBtn.disabled = b; }
      if (emailBtnLabel) { emailBtnLabel.textContent = b ? cfg.strings.loading : emailBtnDefault; }
    } else {
      if (prenomInput) { prenomInput.disabled = b; }
      if (prenomBtn) { prenomBtn.disabled = b; }
      if (prenomBtnLabel) { prenomBtnLabel.textContent = b ? cfg.strings.loading : prenomBtnDefault; }
    }
    if (b) { announce(cfg.strings.loading); }
  }

  /* ---------- POST sibforms (réponse opaque : then = parti, catch = réseau KO) ---------- */
  function postBrevo(extraFields) {
    var body = new URLSearchParams();
    body.append(cfg.emailField || 'EMAIL', capturedEmail);
    if (extraFields) { for (var f in extraFields) { if (extraFields.hasOwnProperty(f)) { body.append(f, extraFields[f]); } } }
    if (cfg.extra) { for (var k in cfg.extra) { if (cfg.extra.hasOwnProperty(k)) { body.append(k, cfg.extra[k]); } } }
    return fetch(cfg.action, {
      method: 'POST', mode: 'no-cors',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
      body: body.toString()
    });
  }

  /* ---------- ÉTAPE 1 : email ---------- */
  if (emailForm) {
    emailForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (emailInput ? emailInput.value : '').trim();
      if (!isEmail(email)) { setInvalid(); if (emailInput) { emailInput.focus(); } return; }
      clearInvalid();
      capturedEmail = email;
      setLoading('email', true);
      postBrevo(null).then(step1Success).catch(step1Error);
    });
  }
  function step1Success() {
    setLoading('email', false);
    if (!design) { lsSet(K_SUB, '1'); } /* email capturé : plus jamais sur ce device */
    track('submit_success', { step: 1 });
    showView('prenom');
    focusView('prenom');
  }
  function step1Error() {                 /* réseau KO à l'étape 1 : email conservé */
    setLoading('email', false);
    track('submit_error', { step: 1 });
    showView('error');
    focusView('error');
    announce(cfg.strings.errorA11y);
  }

  var retry = root.querySelector('[data-gr-nl-retry]');
  if (retry) {
    retry.addEventListener('click', function () {
      showView('email');
      if (emailInput) { emailInput.disabled = false; emailInput.focus(); }
    });
  }

  /* ---------- ÉTAPE 2 : prénom (contact déjà capturé -> succès quoi qu'il arrive) ---------- */
  if (prenomForm) {
    prenomForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var name = (prenomInput ? prenomInput.value : '').trim();
      if (!name) {
        root.classList.add('gr-nl--invalid');
        if (prenomInline) { prenomInline.textContent = cfg.strings.inlinePrenom; }
        if (prenomInput) { prenomInput.setAttribute('aria-invalid', 'true'); prenomInput.focus(); }
        announce(cfg.strings.inlinePrenom);
        return;
      }
      root.classList.remove('gr-nl--invalid');
      if (prenomInline) { prenomInline.textContent = ''; }
      if (prenomInput) { prenomInput.removeAttribute('aria-invalid'); }
      setLoading('prenom', true);
      var extra = {}; extra[cfg.firstnameField || 'PRENOM'] = name;
      postBrevo(extra).then(function () { step2Done(true); }).catch(function () { step2Done(false); });
    });
  }
  if (prenomInput) {
    prenomInput.addEventListener('input', function () {
      if (prenomInput.value.trim()) {
        root.classList.remove('gr-nl--invalid');
        if (prenomInline) { prenomInline.textContent = ''; }
        prenomInput.removeAttribute('aria-invalid');
      }
    });
  }

  function step2Done(ok) {
    setLoading('prenom', false);
    track(ok ? 'submit_success' : 'submit_error', { step: 2 });
    showView('succes');
    focusView('succes');
    announce(cfg.strings.succesA11y);
  }

  /* ---------- mobile : garder la carte au-dessus du clavier ---------- */
  if (window.visualViewport && card) {
    var vv = window.visualViewport;
    function onVV() {
      if (root.hidden || isDesktop()) { card.style.transform = ''; return; }
      var kb = window.innerHeight - vv.height - vv.offsetTop;
      card.style.transform = (kb > 60) ? ('translateY(-' + Math.round(kb) + 'px)') : '';
    }
    vv.addEventListener('resize', onVV);
    vv.addEventListener('scroll', onVV);
    root.addEventListener('blur', function () { setTimeout(function () { card.style.transform = ''; }, 120); }, true);
  }
})();
